// src/locales/si/purchaseOrder.js
export const purchaseOrder = {
  // Page titles and navigation
  createPurchaseOrder: 'මිලදී ගැනීමේ ඇණවුමක් සාදන්න',
  createPurchaseOrderDescription: 'ඉන්වෙන්ටරි සඳහා නව මිලදී ගැනීමේ ඇණවුමක් සාදන්න',
  editPurchaseOrder: 'මිලදී ගැනීමේ ඇණවුම සංස්කරණය කරන්න',
  editPurchaseOrderDescription: 'මිලදී ගැනීමේ ඇණවුම් විස්තර යාවත්කාලීන කරන්න',
  purchaseOrderDetails: 'මිලදී ගැනීමේ ඇණවුම් විස්තර',
  backToPurchaseOrders: 'මිලදී ගැනීමේ ඇණවුම් වෙත ආපසු යන්න',
  allPurchaseOrders: 'සියලුම මිලදී ගැනීමේ ඇණවුම්',
  addPurchaseOrder: 'මිලදී ගැනීමේ ඇණවුමක් එක් කරන්න',

  // List page
  manageAndTrackPurchaseOrders: 'ඉන්වෙන්ටරි සඳහා සියලුම මිලදී ගැනීමේ ඇණවුම් කළමනාකරණය කිරීම සහ නිරීක්ෂණය කිරීම',
  noPurchaseOrdersYet: 'තවමත් මිලදී ගැනීමේ ඇණවුම් නැත',
  noPurchaseOrdersYetDescription: 'ඉන්වෙන්ටරි මිලදී ගැනීම් කළමනාකරණය කිරීම ආරම්භ කිරීමට ඔබේ පළමු මිලදී ගැනීමේ ඇණවුම සාදන්න.',
  noPurchaseOrdersFound: 'මිලදී ගැනීමේ ඇණවුම් හමු නොවීය',
  noPurchaseOrdersFoundDescription: 'ඔබේ වත්මන් පෙරහන්වලට ගැලපෙන මිලදී ගැනීමේ ඇණවුම් කිසිවක් නැත. ඔබේ සෙවුම් නිර්ණායක සකස් කිරීමට උත්සාහ කරන්න.',
  createFirstPurchaseOrder: 'පළමු මිලදී ගැනීමේ ඇණවුම සාදන්න',
  searchByPoNumber: 'PO අංකයෙන් සොයන්න...',
  allWarehouses: 'සියලුම ගබඩා',
  allSuppliers: 'සියලුම සැපයුම්කරුවන්',
  allStatuses: 'සියලුම තත්ත්වයන්',
  dateRange: 'දින පරාසය',
  totalItems: 'මුළු අයිතම',
  receiveOrder: 'ඇණවුම ලබාගන්න',

  // Edit messages
  loadingOrder: 'ඇණවුම පූරණය වෙමින්',
  cannotEditOrder: 'මෙම මිලදී ගැනීමේ ඇණවුම සංස්කරණය කළ නොහැක',
  confirmUpdate: 'ඔබට මෙම මිලදී ගැනීමේ ඇණවුම යාවත්කාලීන කිරීමට අවශ්‍ය බව විශ්වාසද?',
  confirmUpdateTitle: 'යාවත්කාලීන කිරීම තහවුරු කරන්න',
  purchaseOrderUpdated: 'මිලදී ගැනීමේ ඇණවුම {{orderNumber}} සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToUpdate: 'මිලදී ගැනීමේ ඇණවුම යාවත්කාලීන කිරීමට අසමත් විය',
  failedToLoadOrder: 'මිලදී ගැනීමේ ඇණවුම පූරණය කිරීමට අසමත් විය',
  updateOrder: 'ඇණවුම යාවත්කාලීන කරන්න',
  updateWarning: 'මෙය නව විස්තර සමඟ මිලදී ගැනීමේ ඇණවුම යාවත්කාලීන කරනු ඇත.',
  updatingOrder: 'යාවත්කාලීන කරමින්...',
  orderNotEditable: 'මෙම ඇණවුම සංස්කරණය කළ නොහැක ({{status}})',
  
  // Form sections
  basicInformation: 'මූලික තොරතුරු',
  purchaseOrderItems: 'මිලදී ගැනීමේ ඇණවුම් අයිතම',
  financialDetails: 'මූල්‍ය විස්තර',
  
  // Basic information fields
  warehouse: 'ගබඩාව',
  warehouseRequired: 'ගබඩාව අවශ්‍ය වේ',
  selectWarehouse: 'ගබඩාව තෝරන්න',
  
  supplier: 'සැපයුම්කරු',
  supplierRequired: 'සැපයුම්කරු අවශ්‍ය වේ',
  selectSupplier: 'සැපයුම්කරු තෝරන්න හෝ සොයන්න',
  createNewSupplier: 'නව සැපයුම්කරුවෙකු සාදන්න',
  supplierName: 'සැපයුම්කරු නම',
  supplierContact: 'සම්බන්ධතා පුද්ගලයා',
  supplierEmail: 'විද්‍යුත් තැපෑල',
  supplierPhone: 'දුරකථන',
  changeSupplier: 'සැපයුම්කරු වෙනස් කරන්න',
  createSupplierWithName: '"{{name}}" සාදන්න',
  
  orderDate: 'ඇණවුම් දිනය',
  orderDateRequired: 'ඇණවුම් දිනය අවශ්‍ය වේ',
  
  expectedDeliveryDate: 'අපේක්ෂිත බෙදාහැරීමේ දිනය',
  expectedDeliveryDateOptional: 'අපේක්ෂිත බෙදාහැරීමේ දිනය (විකල්ප)',
  
  status: 'තත්ත්වය',
  statusDraft: 'කෙටුම්පත',
  statusPending: 'විචාරාධීන',
  statusReceived: 'ලැබී ඇත',
  statusPartial: 'අර්ධ වශයෙන් ලැබී ඇත',
  statusCancelled: 'අවලංගු කර ඇත',
  
  notes: 'සටහන්',
  notesPlaceholder: 'මෙම මිලදී ගැනීමේ ඇණවුම පිළිබඳව අමතර සටහන් එක් කරන්න...',
  
  autoReceive: 'ස්වයංක්‍රීයව ලබාගන්න',
  autoReceiveTooltip: 'සෑදීමේදී වහාම මෙම ඇණවුම ලැබී ඇති ලෙස සලකුණු කර තොගය යාවත්කාලීන කරන්න',
  autoReceiveWarning: 'මෙය වහාම ඉන්වෙන්ටරි වෙත අයිතම එක් කරනු ඇත',
  
  // Items section
  searchProducts: 'නිෂ්පාදන සොයන්න',
  searchProductsPlaceholder: 'නම, SKU, හෝ බාර්කෝඩ් අනුව සොයන්න...',
  addItem: 'අයිතමය එක් කරන්න',
  removeItem: 'අයිතමය ඉවත් කරන්න',
  atLeastOneItemRequired: 'අවම වශයෙන් එක් අයිතමයක් අවශ්‍ය වේ',
  
  product: 'නිෂ්පාදනය',
  productRequired: 'නිෂ්පාදනය අවශ්‍ය වේ',
  selectProduct: 'නිෂ්පාදනය තෝරන්න',
  
  quantity: 'ප්‍රමාණය',
  quantityRequired: 'ප්‍රමාණය අවශ්‍ය වේ',
  quantityMinimum: 'ප්‍රමාණය 0 ට වඩා වැඩි විය යුතුය',
  
  unitPrice: 'ඒකක මිල',
  unitPriceRequired: 'ඒකක මිල අවශ්‍ය වේ',
  unitPriceMinimum: 'ඒකක මිල 0 ට වඩා වැඩි හෝ සමාන විය යුතුය',
  
  lineTotal: 'පේළි එකතුව',
  lineNotes: 'අයිතම සටහන්',
  lineNotesPlaceholder: 'මෙම අයිතමය සඳහා සටහන් එක් කරන්න...',
  
  // Financial details
  subtotal: 'උප එකතුව',
  extraCharges: 'අමතර ගාස්තු',
  extraChargesPlaceholder: 'උදා: 500.00',
  extraChargesDescription: 'අමතර ගාස්තු විස්තරය',
  extraChargesDescriptionPlaceholder: 'අමතර ගාස්තු විස්තර කරන්න (බෙදාහැරීම, බද්ද, ආදිය)',
  
  discountAmount: 'වට්ටම් මුදල',
  discountAmountPlaceholder: 'උදා: 100.00',
  discountDescription: 'වට්ටම් විස්තරය',
  discountDescriptionPlaceholder: 'වට්ටම් හේතුව විස්තර කරන්න',
  
  grandTotal: 'මුළු එකතුව',
  
  // Product search
  noProductsFound: 'නිෂ්පාදන හමු නොවීය',
  searchingProducts: 'සොයමින්...',
  productSku: "SKU",
  productStock: 'වත්මන් තොගය',
  productPrice: 'පිරිවැය මිල',
  
  // Supplier dialog
  supplierDialogTitle: 'නව සැපයුම්කරුවෙකු සාදන්න',
  supplierDialogDescription: 'ඔබේ පද්ධතියට නව සැපයුම්කරුවෙකු එක් කරන්න',
  supplierNameRequired: 'සැපයුම්කරු නම අවශ්‍ය වේ',
  supplierNamePlaceholder: 'සැපයුම්කරු සමාගමේ නම ඇතුළත් කරන්න',
  supplierContactPlaceholder: 'සම්බන්ධතා පුද්ගල නම ඇතුළත් කරන්න',
  supplierEmailPlaceholder: 'සැපයුම්කරු විද්‍යුත් තැපෑල ඇතුළත් කරන්න',
  supplierPhonePlaceholder: 'සැපයුම්කරු දුරකථන ඇතුළත් කරන්න',
  supplierCreating: 'සැපයුම්කරු සාදමින්...',
  searchingSuppliers: 'සැපයුම්කරුවන් සොයමින්...',
  
  // Actions
  saveAsDraft: 'කෙටුම්පතක් ලෙස සුරකින්න',
  submitOrder: 'ඇණවුම ඉදිරිපත් කරන්න',
  updateOrder: 'ඇණවුම යාවත්කාලීන කරන්න',
  cancel: 'අවලංගු කරන්න',
  
  // Success messages
  purchaseOrderCreated: 'මිලදී ගැනීමේ ඇණවුම {{orderNumber}} සාර්ථකව සාදන ලදී',
  purchaseOrderCreatedAndReceived: 'මිලදී ගැනීමේ ඇණවුම {{orderNumber}} සාර්ථකව සාදා ලබාගන්නා ලදී',
  purchaseOrderUpdated: 'මිලදී ගැනීමේ ඇණවුම සාර්ථකව යාවත්කාලීන කරන ලදී',
  purchaseOrderSaved: 'මිලදී ගැනීමේ ඇණවුම කෙටුම්පතක් ලෙස සුරකින ලදී',
  supplierCreated: 'සැපයුම්කරු සාර්ථකව සාදන ලදී',
  
  // Error messages
  failedToCreate: 'මිලදී ගැනීමේ ඇණවුම සෑදීමට අසමත් විය',
  failedToUpdate: 'මිලදී ගැනීමේ ඇණවුම යාවත්කාලීන කිරීමට අසමත් විය',
  failedToLoadData: 'අවශ්‍ය දත්ත පූරණය කිරීමට අසමත් විය',
  failedToLoadOrder: 'මිලදී ගැනීමේ ඇණවුම පූරණය කිරීමට අසමත් විය',
  failedToCreateSupplier: 'සැපයුම්කරු සෑදීමට අසමත් විය',
  cannotEditReceived: 'ලැබී ඇති මිලදී ගැනීමේ ඇණවුමක් සංස්කරණය කළ නොහැක',
  cannotEditCancelled: 'අවලංගු කළ මිලදී ගැනීමේ ඇණවුමක් සංස්කරණය කළ නොහැක',
  cannotEditActiveReceipts: 'මෙම මිලදී ගැනීමේ ඇණවුමට සක්‍රිය GRN හෝ සැපයුම්කරුට ආපසු යැවීම් වාර්තා ඇත. සංස්කරණය කිරීමට පෙර ඒවා අවලංගු කරන්න.',
  
  // Validation messages
  pleaseFixErrors: 'ඉදිරිපත් කිරීමට පෙර දෝෂ නිවැරදි කරන්න',
  unsavedChanges: 'ඔබට නොසුරකින ලද වෙනස්කම් ඇත. ඔබට පිටවීමට අවශ්‍ය බව විශ්වාසද?',
  confirmSubmit: 'ඔබට මෙම මිලදී ගැනීමේ ඇණවුම ඉදිරිපත් කිරීමට අවශ්‍ය බව විශ්වාසද?',
  confirmSubmitTitle: 'ඉදිරිපත් කිරීම තහවුරු කරන්න',
  confirmDraft: 'මෙම මිලදී ගැනීමේ ඇණවුම කෙටුම්පතක් ලෙස සුරකින්නද?',
  
  // Loading states
  loadingWarehouses: 'ගබඩා පූරණය වෙමින්...',
  loadingSuppliers: 'සැපයුම්කරුවන් පූරණය වෙමින්...',
  loadingProducts: 'නිෂ්පාදන පූරණය වෙමින්...',
  loadingOrder: 'මිලදී ගැනීමේ ඇණවුම පූරණය වෙමින්...',
  loadingMessage: 'අවශ්‍ය දත්ත පූරණය වන තුරු කරුණාකර රැඳී සිටින්න...',
  loadingOrderMessage: 'ඇණවුම් දත්ත පූරණය වන තුරු කරුණාකර රැඳී සිටින්න...',
  submittingOrder: 'ඇණවුම ඉදිරිපත් කරමින්...',
  
  // Empty states
  noWarehousesAvailable: 'ගබඩා ලබා ගත නොහැක',
  noSuppliersAvailable: 'සැපයුම්කරුවන් හමු නොවීය',
  noItemsAdded: 'තවමත් අයිතම එකතු කර නැත',
  addItemsToOrder: 'මෙම මිලදී ගැනීමේ ඇණවුමට අයිතම එකතු කරන්න',
  
  // Tooltips and hints
  warehouseHint: 'තොගය ලැබෙන ගබඩාව තෝරන්න',
  supplierHint: 'මෙම ඇණවුම සඳහා සැපයුම්කරු සොයා තෝරන්න',
  orderDateHint: 'මිලදී ගැනීමේ ඇණවුම සාදන ලද දිනය',
  expectedDeliveryHint: 'අයිතම බෙදා හරින අපේක්ෂිත දිනය',
  autoReceiveHint: 'ඇණවුම සෑදීමේදී වහාම තොගය යාවත්කාලීන කිරීමට මෙය පරීක්ෂා කරන්න',
  
  // Table headers
  itemNumber: "#",
  itemProduct: 'නිෂ්පාදනය',
  itemQuantity: 'ප්‍රමාණය',
  itemUnitPrice: 'ඒකක මිල',
  itemLineTotal: 'එකතුව',
  itemActions: 'ක්‍රියාවන්',
  
  // Currency
  currency: 'රු.',
  
  // Common
  required: 'අවශ්‍ය වේ',
  optional: 'විකල්ප',
  loading: 'පූරණය වෙමින්...',
  search: 'සොයන්න',
  create: 'සාදන්න',
  update: 'යාවත්කාලීන කරන්න',
  save: 'සුරකින්න',
  delete: 'මකන්න',
  view: 'බලන්න',
  edit: 'සංස්කරණය කරන්න',
  
  // Order number
  orderNumber: 'ඇණවුම් අංකය',
  poNumber: 'PO අංකය',
  generatedOrderNumber: 'ජනනය කළ ඇණවුම් අංකය',

  // Receive action
  confirmReceiveTitle: "ඇණවුම ලැබීම තහවුරු කරන්න",
  confirmReceive: "මෙම මිලදී ගැනීමේ ඇණවුම ලැබුණු ලෙස සලකුණු කිරීමට ඔබට විශ්වාසද? සියලුම අයිතම සම්පූර්ණයෙන් ලැබෙන අතර තොගය යාවත්කාලීන වේ.",
  receivingOrder: "ලබාගනිමින්...",
  purchaseOrderReceived: "මිලදී ගැනීමේ ඇණවුම {orderNumber} ලැබුණු ලෙස සලකුණු කරන ලදී",
  failedToReceive: "මිලදී ගැනීමේ ඇණවුම ලබා ගැනීමට අසමත් විය",

  // Details page
  purchaseOrderDetailsDescription: "මෙම මිලදී ගැනීමේ ඇණවුමේ සම්පූර්ණ විස්තර බලන්න",
  orderInformation: "ඇණවුම් තොරතුරු",
  supplierInformation: "සැපයුම්කරුගේ තොරතුරු",
  warehouseInformation: "ගබඩා තොරතුරු",
  itemsOrdered: "ඇණවුම් කළ අයිතම",
  financialSummary: "මූල්‍ය සාරාංශය",
  auditInformation: "විගණන තොරතුරු",
  receivedQuantity: "ලැබුණු ප්‍රමාණය",
  orderedQuantity: "ඇණවුම් කළ ප්‍රමාණය",
  receivedBy: "ලබාගත්තේ",
  receivedDate: "ලැබුණු දිනය",
  cancelledBy: "අවලංගු කළේ",
  cancelledAt: "අවලංගු කළ දිනය",
  cancellationReason: "අවලංගු කිරීමට හේතුව",
  noCancellationReason: "හේතුවක් සපයා නැත",
  confirmCancelTitle: "මිලදී ගැනීමේ ඇණවුම අවලංගු කරන්න",
  confirmCancel: "මෙම මිලදී ගැනීමේ ඇණවුම අවලංගු කිරීමට ඔබට විශ්වාසද? මෙම ක්‍රියාව ආපසු හැරවිය නොහැක.",
  cancellationReasonLabel: "අවලංගු කිරීමට හේතුව (විකල්ප)",
  cancellationReasonPlaceholder: "අවලංගු කිරීමට හේතුවක් ඇතුළත් කරන්න...",
  cancellingOrder: "අවලංගු කරමින්...",
  purchaseOrderCancelled: "මිලදී ගැනීමේ ඇණවුම {orderNumber} අවලංගු කරන ලදී",
  failedToCancel: "මිලදී ගැනීමේ ඇණවුම අවලංගු කිරීමට අසමත් විය",
  noNotes: "සටහන් නැත",
  contactPerson: "සම්බන්ධතා පුද්ගලයා",
  variation: "ප්‍රභේදය",
  notSpecified: "සඳහන් කර නැත",
  partiallyReceived: "අර්ධ වශයෙන් ලැබී ඇත",
  fullyReceived: "සම්පූර්ණයෙන් ලැබී ඇත",
  notYetReceived: "තවම ලැබී නැත",

  // Export / Download
  downloadPdf: 'PDF බාගත කරන්න',
  downloadExcel: 'Excel බාගත කරන්න',
  downloading: 'බාගත කරමින්...',

  // Reverse action
  reverseOrder: 'ඇණවුම ආපසු හරවන්න',
  confirmReverseTitle: 'මිලදී ගැනීමේ ඇණවුම ආපසු හරවන්න',
  confirmReverse: 'මෙය මෙම මිලදී ගැනීමේ ඇණවුමෙන් සිදු කළ සියලුම කොටු වෙනස්කම් ස්ථිරවම ආපසු හරවනු ඇත. ලැබුණු සියලුම ප්‍රමාණ ඉන්වෙන්ටරිය වෙතින් ඉවත් කෙරෙනු ඇත.',
  confirmReverseTypeYes: 'මෙම ක්‍රියාව තහවුරු කිරීමට YES ටයිප් කරන්න',
  confirmReverseTypePlaceholder: 'YES මෙහි ටයිප් කරන්න',
  reversingOrder: 'ආපසු හරවමින්...',
  purchaseOrderReversed: 'මිලදී ගැනීමේ ඇණවුම {{orderNumber}} ආපසු හරවා ඇත',
  failedToReverse: 'මිලදී ගැනීමේ ඇණවුම ආපසු හරවීමට අසමත් විය',

  // Supplier payments (Payment Records section + Payments modal)
  paymentRecords: 'ගෙවීම් වාර්තා',
  poTotal: 'මිලදී ගැනීමේ ඇණවුම් එකතුව',
  payments: 'ගෙවීම්',
  paymentDetails: 'ගෙවීම් විස්තර',
  outstandingBalance: 'ගෙවිය යුතු ශේෂය',
  debitNotePaymentMethod: 'ණය සටහන',
  selectDebitNote: 'ණය සටහන තෝරන්න',
  searchDebitNote: 'ණය සටහන් සොයන්න...',
  noAvailableDebitNotes: 'මෙම සැපයුම්කරු සඳහා ණය සටහන් නොමැත',
  confirmPayment: 'ගෙවීම තහවුරු කරන්න',
  completePaymentFields: 'කරුණාකර සියලුම ගෙවීම් ක්ෂේත්‍ර සම්පූර්ණ කරන්න',
  paymentRecordedSuccess: 'ගෙවීම සාර්ථකව සටහන් කරන ලදී',
  createGoodsReceivedNote: "GRN සාදන්න",
  createReturnToVendor: "RTV සාදන්න",
  recordPayment: "ගෙවීම සටහන් කරන්න",
  paymentRecordedSuccessfully: "ගෙවීම සාර්ථකව සටහන් කරන ලදී",
  failedToRecordPayment: "ගෙවීම සටහන් කිරීමට අසමත් විය",
  paymentMethodRequired: "කරුණාකර ගෙවීම් ක්‍රමයක් තෝරන්න",
  paymentAmountRequired: "කරුණාකර වලංගු ගෙවීම් මුදලක් ඇතුළත් කරන්න",
  paymentStatus: "ගෙවීම",
  paymentStatus_unpaid: "නොගෙවූ",
  paymentStatus_partial: "අර්ධ වශයෙන් ගෙවා ඇත",
  paymentStatus_paid: "ගෙවා ඇත",
  paidAmount: "ගෙවූ මුදල",
  balanceAmount: "ගෙවිය යුතු ශේෂය",
  relatedDocuments: "සම්බන්ධිත ලේඛන",
  goodsReceivedNotes: "භාණ්ඩ ලැබුණු සටහන්",
  returnsToVendor: "සැපයුම්කරුට ආපසු යැවීම්",
  debitNotes: "ණය සටහන්",
  paymentHistory: "ගෙවීම් ඉතිහාසය",
  noRelatedDocuments: "තවම නැත",
  paymentDate: "ගෙවීම් දිනය",
  paymentMethod: "ගෙවීම් ක්‍රමය",
  paymentAmount: "මුදල",
  paymentReference: "යොමුව",
  activityHistory: "ක්‍රියාකාරකම් ඉතිහාසය",
  noActivity: "තවම ක්‍රියාකාරකම් සටහන් වී නැත",
  loadMore: "තවත් පූරණය කරන්න",
  auditHistory: "විගණන ඉතිහාසය",
  totalChanges: "මුළු වෙනස්කම්",
  lastModified: "අවසන් වරට වෙනස් කළේ",
  auditEmpty: "හිස්",
  auditBy: "{{name}} විසින්",
  auditTag_payment: "ගෙවීම් වාර්තාව",
  auditTag_grn: "GRN",
  auditTag_rtv: "සැපයුම්කරුට ආපසු",
  auditTag_debitNote: "හර සටහන",
  auditField_paymentDate: "ගෙවීම් දිනය",
  previous: "පෙර",
  next: "ඊළඟ",
  pageOf: "පිටුව {{page}} / {{total}}",
  noPaymentRecords: "තවම ගෙවීම් සටහන් වී නැත",
  returnedToVendor: "සැපයුම්කරුට ආපසු යවන ලදී",
  voided: "අවලංගු කළා",
  audit_CREATE: "මිලදී ගැනීමේ ඇණවුම සාදන ලදී",
  audit_UPDATE: "මිලදී ගැනීමේ ඇණවුම යාවත්කාලීන කරන ලදී",
  audit_STATUS_CHANGED: "තත්ත්වය වෙනස් කරන ලදී",
  audit_CANCEL: "මිලදී ගැනීමේ ඇණවුම අවලංගු කරන ලදී",
  audit_RECEIVE_FULL: "සම්පූර්ණයෙන් ලබා ගන්නා ලදී",
  audit_PAYMENT_ADDED: "ගෙවීම සටහන් කරන ලදී",
  audit_PAYMENT_UPDATED: "ගෙවීම යාවත්කාලීන කරන ලදී",
  audit_PAYMENT_REMOVED: "ගෙවීම ඉවත් කරන ලදී",
  audit_GRN_CREATED: "භාණ්ඩ ලැබුණු සටහන සාදන ලදී",
  audit_GRN_CANCELLED: "භාණ්ඩ ලැබුණු සටහන අවලංගු කරන ලදී",
  audit_RTV_CREATED: "සැපයුම්කරුට ආපසු යැවීම සාදන ලදී",
  audit_RTV_VOIDED: "සැපයුම්කරුට ආපසු යැවීම අවලංගු කරන ලදී",
  audit_DEBIT_NOTE_ISSUED: "ණය සටහන නිකුත් කරන ලදී",
  audit_DEBIT_NOTE_APPLIED: "ණය සටහන යොදන ලදී",
  audit_DEBIT_NOTE_CANCELLED: "ණය සටහන අවලංගු කරන ලදී",
  auditField_purchaseOrderNumber: "ඇණවුම් අංකය",
  auditField_status: "තත්ත්වය",
  auditField_grandTotal: "මුළු එකතුව",
  auditField_totalAmount: "උප එකතුව",
  auditField_extraCharges: "අමතර ගාස්තු",
  auditField_discountAmount: "වට්ටම",
  auditField_orderDate: "ඇණවුම් දිනය",
  auditField_expectedDeliveryDate: "අපේක්ෂිත බෙදාහැරීම",
  auditField_notes: "සටහන්",
  auditField_supplierName: "සැපයුම්කරු",
  auditField_extraChargesDescription: "අමතර ගාස්තු සටහන",
  auditField_discountDescription: "වට්ටම් සටහන",
  auditField_autoReceive: "ස්වයංක්‍රීය ලැබීම",
  auditField_warehouseName: "ගබඩාව",
  auditField_items: "අයිතම",
  auditField_itemCount: "අයිතම",
  auditField_amount: "මුදල",
  auditField_method: "ගෙවීම් ක්‍රමය",
  auditField_reference: "යොමුව",
  auditField_grnNumber: "GRN අංකය",
  auditField_rtvNumber: "RTV අංකය",
  auditField_debitNoteNumber: "ණය සටහන",
  auditField_totalDebitAmount: "ණය මුදල",
  auditField_quantityReceived: "ලැබුණු ප්‍රමාණය",
  auditField_sourceType: "මූලාශ්‍රය",
  auditField_proofUrl: "සාක්ෂි ගොනුව",
  auditField_quantity: "ප්‍රමාණය",
  auditField_unitPrice: "ඒකක මිල",
  auditField_lineTotal: "පේළි එකතුව",
  auditItemAdded: "අයිතමය එක් කළා",
  auditItemRemoved: "අයිතමය ඉවත් කළා",
  auditItemUpdated: "අයිතමය යාවත්කාලීන කළා",
  auditViewFile: "ගොනුව බලන්න",
  auditLegacyItems: "අයිතම යාවත්කාලීන කළා ({{count}}) — විස්තර සටහන් කර නැත",
  quantityMustBeGreaterThanZero: "ප්‍රමාණය අවම වශයෙන් 1 විය යුතුය",
  quantityMustBeWholeNumber: "ප්‍රමාණය පූර්ණ සංඛ්‍යාවක් විය යුතුය",
  unitPriceRequired: "ඒකක මිල අවශ්‍යයි",
  openFullDetails: "සම්පූර්ණ විස්තර විවෘත කරන්න",
};